import React from 'react';
import Logo from '../../Image/Logo.jpg';

interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-900">
      <div className="text-center px-6">
        <div className="mb-6 inline-flex rounded-md bg-white p-3 shadow-panel">
          <img
            src={Logo}
            alt="Logo"
            className="h-12 w-auto object-contain"
          />
        </div>
        <div className="flex items-center justify-center gap-3 mb-2">
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-white/20 border-t-accent-400"></div>
          <span className="text-sm font-semibold text-white/90">{message}</span>
        </div>
        <p className="text-xs text-white/45 tracking-[0.12em] uppercase">FleetWMS Console</p>
      </div>
    </div>
  );
}
